// 모듈 코드 → 아이콘 — 아이콘은 DB(s_module)에 없으므로 호스트가 로컬로 들고 있는다.
// 사이드바(18px, 선 1.8)와 상단 탭(13px, 선 2)이 같은 도형을 크기만 달리해 쓴다.
// API 에만 있는 새 모듈(여기 없는 코드)은 범용 아이콘으로 그린다.
import React from 'react';
import type { MessageKey } from '../../lib/locale.messages';

const ICON_PATHS: Record<string, JSX.Element> = {
  fi: <><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/></>,
  tax: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h6M9 9h1"/></>,
  pjt: <><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M8 2v4M16 2v4M3 10h18M8 14h3M8 17h6"/></>,
  ops: <><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></>,
  hr: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></>,
  sd: <><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><path d="M7 7h.01"/></>,
  mm: <><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></>,
  pp: <path d="M2 20h20M4 20V9l5 3V9l5 3V5h6v15M8 16h2M14 16h2"/>,
  log: <><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></>,
  co: <><path d="M21.21 15.89A10 10 0 1 1 8 2.83"/><path d="M22 12A10 10 0 0 0 12 2v10z"/></>,
  crm: <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>,
};

/** 범용 아이콘 — 격자 */
const GENERIC_PATH = <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>;

export function ModuleIcon({ moduleCd, size = 18, strokeWidth = 1.8 }: { moduleCd: string; size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {ICON_PATHS[moduleCd] || GENERIC_PATH}
    </svg>
  );
}

/** 번역 키 폴백 — API 이름이 없거나 API 를 못 읽었을 때 쓴다. 새 모듈(키 없음)은 모듈 코드를 대문자로 보인다 */
export const MODULE_LABEL_KEYS: Record<string, MessageKey> = {
  fi: 'nav.finance', tax: 'nav.tax', basicinfo: 'nav.basicinfo', pjt: 'nav.pjt', ops: 'nav.ops', hr: 'nav.hr',
  sd: 'nav.sd', mm: 'nav.mm', pp: 'nav.pp', log: 'nav.log', co: 'nav.co', crm: 'nav.crm',
};
